import { Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout.jsx';
import ProtectedRoute from './components/ProtectedRoute.jsx';
import Login from './pages/Login.jsx';
import Dashboard from './pages/Dashboard.jsx';
import Clients from './pages/Clients.jsx';
import ClientDetail from './pages/ClientDetail.jsx';
import Users from './pages/Users.jsx';
import Settings from './pages/Settings.jsx';
import CaeRequests from './pages/CaeRequests.jsx';
import OperationLogs from './pages/OperationLogs.jsx';

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
        <Route path="/" element={<Dashboard />} />
        <Route path="/clients" element={<ProtectedRoute roles={['superadmin']}><Clients /></ProtectedRoute>} />
        <Route path="/clients/:id" element={<ProtectedRoute roles={['superadmin', 'admin']}><ClientDetail /></ProtectedRoute>} />
        <Route path="/cae-requests" element={<CaeRequests />} />
        <Route path="/operation-logs" element={<OperationLogs />} />
        <Route path="/users" element={<Users />} />
        <Route path="/settings" element={<ProtectedRoute roles={['superadmin']}><Settings /></ProtectedRoute>} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
